import React from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import Dashboard from './user/Dashboard'
import UserPayment from './user/Payment'
import ManagerDashboard from './manager/Dashboard'
import ManagerPayment from './manager/Payment'
import Notification from './manager/Notification'
import Kitchen from './kitchen/kitchen'
import Index from './admin/Index'
import Login from './Login'
import Register from './admin/Register'
import User from './admin/User'
import Adduser from './admin/Adduser'
import Menu from './admin/Menu'
import Addmenu from './admin/Addmenu'
import Category from './admin/Category'
import Addcategory from './admin/Addcategory'
import Table from './admin/Table'
import Addtable from './admin/Addtable'
import Order from './admin/Order'
import Addorder from './admin/AddOrder'
import Payment from './admin/Payment'
import Addpayment from './admin/AddPayment'
import Header from './components/Header'
import Footer from './components/Footer'
import Sidebar from './components/Sidebar'
import ProtectedRoute from './ProtectedRoute'

// 👇 This is where useLocation works
function LayoutRoutes() {
  const location = useLocation();
  const currentPath = location.pathname;

  // paths where we DON’T want header/sidebar/footer
  const noLayoutPaths = ['/'];

  const showLayout = !noLayoutPaths.includes(currentPath);

  return (
    <>
    
      <Routes>
        <Route path="/protectedroute" element={<ProtectedRoute />} />
      {/* ✅ Dashboard route OUTSIDE the layout */}

      <Route path="/" element={<ProtectedRoute allowedRoles={["customer"]}><Dashboard /></ProtectedRoute>} />
      <Route path="/userpayment" element={<ProtectedRoute allowedRoles={["customer"]}><UserPayment /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute allowedRoles={["manager"]}><ManagerDashboard /></ProtectedRoute>} />
      <Route path="/managerpayment" element={<ProtectedRoute allowedRoles={["manager"]}><ManagerPayment /></ProtectedRoute>} />
      <Route path="/notification" element={<ProtectedRoute allowedRoles={["manager"]}><Notification /></ProtectedRoute>} />
      <Route path="/kitchen" element={<ProtectedRoute allowedRoles={["kitchen"]}><Kitchen /></ProtectedRoute>} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      



      {/* ✅ All other routes WITH layout */}
      <Route
        path="/*"
        element={
          <div className="container-scroller">
            {showLayout && <Sidebar />}
            <div className="container-fluid page-body-wrapper">
              {showLayout && <Header />}
              <div className="main-panel">
                <Routes>
                  <Route path="/index" element={<ProtectedRoute allowedRoles={["admin"]}><Index /></ProtectedRoute>} />
                  <Route path="/user" element={<ProtectedRoute allowedRoles={["admin"]}><User /></ProtectedRoute>} />
                  <Route path="/adduser" element={<ProtectedRoute allowedRoles={["admin"]}><Adduser /></ProtectedRoute>} />
                  <Route path="/category" element={<ProtectedRoute allowedRoles={["admin"]}><Category /></ProtectedRoute>} />
                  <Route path="/addcategory" element={<ProtectedRoute allowedRoles={["admin"]}><Addcategory /></ProtectedRoute>} />
                  <Route path="/menu" element={<ProtectedRoute allowedRoles={["admin"]}><Menu /></ProtectedRoute>} />
                  <Route path="/addmenu" element={<ProtectedRoute allowedRoles={["admin"]}><Addmenu /></ProtectedRoute>} />
                  <Route path="/table" element={<ProtectedRoute allowedRoles={["admin"]}><Table /></ProtectedRoute>} />
                  <Route path="/addtable" element={<ProtectedRoute allowedRoles={["admin"]}><Addtable /></ProtectedRoute>} />
                  <Route path="/order" element={<ProtectedRoute allowedRoles={["admin"]}><Order /></ProtectedRoute>} />
                  <Route path="/addorder" element={<ProtectedRoute allowedRoles={["admin"]}><Addorder /></ProtectedRoute>} />
                  <Route path="/payment" element={<ProtectedRoute allowedRoles={["admin"]}><Payment /></ProtectedRoute>} />
                  <Route path="/addpayment" element={<ProtectedRoute allowedRoles={["admin"]}><Addpayment /></ProtectedRoute>} />
                </Routes>
                {showLayout && <Footer />}
              </div>
            </div>
          </div>
        }
      />
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <LayoutRoutes />
    </BrowserRouter>
  );
}

export default App;
